<template>
  <HoverCard :open-delay="150">
    <HoverCardTrigger as-child>
      <span
        v-bind="$attrs"
        class="inline-flex items-center cursor-default"
        tabindex="0"
        aria-label="Discovered by Outtalent"
      >
        <Sparkles class="w-4 h-4 text-cosmicPurple fill-cosmicPurple stroke-1 animate-sparkle" />
      </span>
    </HoverCardTrigger>
    <HoverCardContent side="top" class="w-64 p-3 text-xs">
      <p class="flex items-center gap-1.5 font-medium text-gray-900">
        <Sparkles class="w-3.5 h-3.5 text-cosmicPurple fill-cosmicPurple stroke-1" />
        Discovered by Outtalent
      </p>
      <p class="mt-1 text-gray-600">
        Our job finder spotted this opening on the company's careers page. Double-check the
        details on the original posting before applying.
      </p>
    </HoverCardContent>
  </HoverCard>
</template>

<script setup lang="ts">
import { Sparkles } from 'lucide-vue-next'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card'

defineOptions({ inheritAttrs: false })
</script>
